var _ellipse, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 105,
    viewBox: "0 0 104 105",
    width: 104,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.119,
    cy: 81.1425,
    fill: "#fff",
    rx: 12.3095,
    ry: 5.83378
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m56.1422 4.47006.1938.20739.1047.11701.2923.37104 8.8107 12.723c3.6969 5.3386 5.7977 11.6351 6.0621 18.1859l.0207.6786.0068.6689v5.5949l7.1081 7.983c.883.9916 1.428 2.2371 1.5657 3.5536l.0259.3305.0087.3329v17.9305c0 5.6792-6.807 8.4159-10.6597 4.4121l-.1812-.1958-2.5104-2.8195-.1298.0732-.2036.1032v.5656c0 3.1972-1.42 6.599-3.6869 8.5211 0 0-1.3095 1.0477-1.8007 1.1119l-.5754.0038.4722.0038h-.7085l-1.0477-.0076s-1.0956.0074-1.0476.0076l-1.5714-.0076h-1.0476-1.3096l-3.9285.0076h-2.2239-1.7047l-1.0476.0001-.7857-.0077-1.0477.0077-.7893-.0001c-2.8839-.8673-5.7102-5.6092-5.9751-8.8789l-.0242-.3793-.0076-.3824v-.5669l-.3334-.1776-2.5109 2.8227c-3.4995 3.9301-9.8122 1.9787-10.7309-3.0249l-.0427-.2615-.0327-.2669-.0203-.2637-.0072-.141-.0066-.259v-17.9305c0-1.176.3251-2.3245.9332-3.3179l.1909-.2933.0878-.127.2858-.3636 7.2095-8.1007.0013-5.5924c0-6.2952 1.7247-12.4567 4.9921-17.8403l.3559-.5738.3678-.5677.3737-.5516 8.7223-12.59534c2.2449-3.24173 6.8107-3.58095 9.5071-.8231z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m52.7347 8.04591.099.12574 8.7223 12.59535c3.26 4.7077 5.0611 10.2865 5.1814 16.0255l.0065.6155v7.5309l8.3883 9.4205c.2061.2314.3201.5319.3201.8434v17.9305c0 1.1539-1.405 1.7004-2.1681.8434l-6.5406-7.3481c-.0239 2.1294-1.678 3.8623-3.758 3.9793l-.2244.0063-.9936-.0013v4.6592c0 2.9047-2.2573 5.2755-5.0926 5.4125l-.2593.0062h-9.2012c-2.8688 0-5.2105-2.2854-5.3457-5.1561l-.0062-.2626v-4.6592l-.9936.0013c-2.1237 0-3.8592-1.683-3.9763-3.8035l-.0064-.1818-6.5403 7.3478c-.7313.8213-2.0521.3536-2.1609-.7024l-.0072-.141v-17.9305c0-.2596.0792-.5115.2248-.7222l.0953-.1212 8.3871-9.4205.0012-7.5309c0-5.7495 1.6887-11.3643 4.8442-16.1333l.3437-.5077 8.7223-12.59535c.4644-.67059 1.4132-.71251 1.9382-.12574z",
    fill: "#e60000",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m51.8149 11.0885 7.7036 11.1242c3.0831 4.4521 4.737 9.7575 4.737 15.1948v29.1739c0 .8357-.6691 1.5131-1.4945 1.5131l-5.9711-.0012.0013-18.8925c0-2.7826-2.228-5.0383-4.9763-5.0383s-4.9762 2.2557-4.9762 5.0383l-.0013 18.8925-5.9686.0012c-.8254 0-1.4945-.6774-1.4945-1.5131v-29.1739c0-5.4373 1.6539-10.7427 4.737-15.1948z",
    fillOpacity: 0.84,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m51.8157 46.6821c1.3742 0 2.4881 1.1279 2.4881 2.5192l-.0012 18.8924h-4.9763l.0013-18.8924c0-1.3913 1.114-2.5192 2.4881-2.5192z",
    fillOpacity: 0.84,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m66.7432 48.6987 6.2203 6.9868v14.169l-6.2203-6.9868z",
    fillOpacity: 0.68,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m44.3501 70.6141h2.4881c0 2.7826 2.2279 5.0384 4.9762 5.0384s4.9763-2.2558 4.9763-5.0384h2.4881v4.658c0 1.6014-1.2822 2.8995-2.8638 2.8995h-9.2012l-.196-.0067c-1.4902-.102-2.6677-1.3582-2.6677-2.8928z",
    fillOpacity: 0.68,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m49.3257 70.6141h4.9763c0 1.3913-1.114 2.5192-2.4881 2.5192-1.3742 0-2.4882-1.1279-2.4882-2.5192z",
    fillOpacity: 0.68,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m36.8856 48.6986v14.169l-6.2203 6.9869v-14.169z",
    fillOpacity: 0.68,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.816 46.6818c1.3741 0 2.4881 1.1278 2.4881 2.5191v21.4129c0 1.3913-1.114 2.5192-2.4881 2.5192-1.3742 0-2.4881-1.1279-2.4881-2.5192v-21.4129c0-1.3913 1.1139-2.5191 2.4881-2.5191z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.508 33.703c0 2.6927-2.1519 4.849-4.7738 4.849-2.622 0-4.7738-2.1563-4.7738-4.849 0-2.6926 2.1518-4.8489 4.7738-4.8489 2.6219 0 4.7738 2.1563 4.7738 4.8489z",
    stroke: "#e60000",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg0);
export default __webpack_public_path__ + "static/media/img_0.e41f0ed8d7a03ceff4498fd996467fd8.svg";
export { ForwardRef as ReactComponent };